<template>
  <v-flex v-if="requirementsEmpty" px-1 class="nowrap flex-basis-0 flex-grow-0">
    <div pa-0 class="display-18 pa-0" wrap>
      <span v-for="(scope, index) in scopes" :key="index" class="display-18 region-item">
        <span top v-if="index===0">{{ scope["NameInHebrew"] }}</span>

        <v-tooltip top v-if="index===1">
          <template v-slot:activator="{ on }">
            <span v-on="on" text class="display-18 pointer-underline">ועוד</span>
          </template>
          <span class="display-16 d-block" v-for="(item, i) in scopes" :key="i">
            <span v-if="i>0">{{ item["NameInHebrew"] }}</span>
          </span>
        </v-tooltip>
      </span>
    </div>
  </v-flex>
</template>

<script>
export default {
  props: {
    scopes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      title: 'היקף משרה',
      requirementsEmpty: this.scopes ? true : false
    }
  },

  computed: {
    // requirements() {
    //   let listClean = ''
    //   if (this.list !== null) {
    //     listClean = this.list.split('<br/>')
    //   } else {
    //     listClean = ''
    //     this.requirementsEmpty = false
    //   }
    //   return listClean
    // }
  }
}
</script>

